<app-header></app-header>

<section id="equipo" class="bg-grey reset-section-pad2" *ngIf="isLoaded">

    <div class="container">

          <div class="row">
            <app-title-section
                [titleTxt]="titleTxt"
            ></app-title-section>
         </div>
            <!-- inicio aviso empleo, solo mostrar cuando haya ofertas de empleo-->
           <div class="row" *ngIf="isPosition">

              <div class="col-lg-12 mt-lg-5 mt-3 mb-4 aviso-oferta">
                     <p [innerHTML]="careersStatic.team_desc">

                     </p>
                    <h1 class="text-center fw-bold mt-4" [innerHTML]="careersStatic.team_claim"></h1>
                    <a class="btn btn-rco" routerLink="{{careersStatic.team_button_link}}"><p [innerHTML]="careersStatic.team_button_txt"></p></a>
               </div> 

         </div><!-- fin aviso empleo-->

         <div class="row" *ngIf="isLoaded">
            <div class="col-lg-12 equipo-blq">
                        <app-team-member-block class="col-lg-3 col-md-3 col-sm-6 col-6 equipo-blq-inner" *ngFor="let item of ordererTeamMembers; index as i"
                        [teamMemberBlock_item]="ordererTeamMembers![i]"
                        ></app-team-member-block>
            </div>
         </div>   

        </div>




</section>

<app-footer-main></app-footer-main>
